import { render, staticRenderFns } from "./PlaceInBubble.vue?vue&type=template&id=b64cf0be&scoped=true&"
import script from "./PlaceInBubble.vue?vue&type=script&lang=js&"
export * from "./PlaceInBubble.vue?vue&type=script&lang=js&"
import style0 from "./PlaceInBubble.vue?vue&type=style&index=0&id=b64cf0be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b64cf0be",
  null
  
)

export default component.exports